import { z } from 'zod'

export interface DNIFormData {
  documentType: number | null
  documentNumber: string
}

export const initialForm: DNIFormData = {
  documentType: null,
  documentNumber: ''
}

const ERRORS = {
  documentType: {
    required_error: 'Este campo es requerido',
    invalid_type_error: 'Ingresa una opción válida'
  },
  documentNumber: {
    required_error: 'Este campo es requerido',
    invalid_type_error: 'Ingresa una opción válida'
  }
} as const

export const DNISchema = z
  .object({
    documentType: z
      .number(ERRORS.documentType)
      .refine(value => value, ERRORS.documentType.required_error),
    documentNumber: z.string(ERRORS.documentNumber).nonempty(ERRORS.documentNumber.required_error)
  })
  .superRefine(({ documentType, documentNumber }, ctx) => {
    if (documentType === 1) {
      if (documentNumber.length !== 8) {
        ctx.addIssue({
          path: ['documentNumber'],
          code: z.ZodIssueCode.custom,
          message: 'El DNI debe contener 8 dígitos'
        })
      }

      return z.NEVER
    }

    const name = documentType === 2 ? 'Pasaporte' : 'Carnet de Extranjería'

    if (documentNumber.length < 6) {
      ctx.addIssue({
        path: ['documentNumber'],
        code: z.ZodIssueCode.custom,
        message: `El ${name} debe tener mínimo 6 dígitos`
      })
    }

    if (documentNumber.length > 12) {
      ctx.addIssue({
        path: ['documentNumber'],
        code: z.ZodIssueCode.custom,
        message: `El ${name} debe tener máximo 6 dígitos`
      })
    }
  })
